import { render, staticRenderFns } from "./PadrillosInPostureModal.vue?vue&type=template&id=2465e7d8&scoped=true"
import script from "./PadrillosInPostureModal.vue?vue&type=script&lang=js"
export * from "./PadrillosInPostureModal.vue?vue&type=script&lang=js"
import style0 from "./PadrillosInPostureModal.vue?vue&type=style&index=0&id=2465e7d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2465e7d8",
  null
  
)

export default component.exports